import { NestedObjectsPathKeys, SortOptions } from '@connect-x-app/shared-types';

import { BaseSort } from './base-sort';
import { Sortable } from './sort';

export class SortDescending<T extends object> extends BaseSort<SortOptions.DESC, T> implements Sortable<T> {
  override type: SortOptions.DESC = SortOptions.DESC;

  constructor(field: NestedObjectsPathKeys<Required<T>>) {
    super(field);
  }
}
